const formatCreatedDateWithSuffix = (dateString) => {
    const date = new Date(dateString);
  
    const day = date.getDate();
    const year = date.getFullYear();
  
    const month = date.toLocaleString("en-IN", { month: "long" });
  
    // Add suffix (st, nd, rd, th)
    const getSuffix = (d) => {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    };
  
    return `${day}${getSuffix(day)} ${month} ${year}`;
  }

export default formatCreatedDateWithSuffix